module.exports = __webpack_public_path__ + "img/mobile-bg.cf07c4b7.png";